
import {
    AdminBuilderScreen,
    EntitiesScreen,
    EntityBuilder,
    EntityDicts,
    EntityDictsDetail,
    EntityFunctions,
} from '@/screens'
import { ENTITIES, TYPES } from '@/entities/entities'
import i18n from '@/lang/i18n'

const components = {
    [TYPES.DICT]: EntityDicts,
    [TYPES.FUNCTION]: EntityFunctions,
    DEFAULT: EntityBuilder,
}

export default meta => [{
    path: 'builder',
    name: 'AdminBuilder',
    component: AdminBuilderScreen,
    redirect: { name: 'Entites' },
    meta,
    children: [
        {
            path: 'list',
            name: 'Entites',
            component: EntitiesScreen,
        },
        ...ENTITIES.map(({
            path, name, label, type,
        }) => ({
            path,
            name,
            component: components[type] || components.DEFAULT,
            meta: {
                key: path,
                breadcrumb: label,
            },
        })),
        {
            path: 'dicts',
            name: 'Dicts',
            component: EntityDicts,
            meta: {
                key: 'dicts',
                breadcrumb: i18n.t('admin.navigation.schema.dicts'),
            },
        },
        {
            path: 'dicts/:dictKey',
            name: 'DictsDetail',
            component: EntityDictsDetail,
            meta: {
                key: 'dicts-detail',
                breadcrumb: i18n.t('admin.navigation.schema.dicts'),
            },
        },
        {
            path: 'transforms',
            name: 'Transforms',
            component: EntityFunctions,
            meta: {
                key: 'transforms',
                breadcrumb: i18n.t('admin.navigation.schema.transforms'),
            },
        },
        {
            path: 'styles',
            name: 'Styles',
            component: EntityFunctions,
            meta: {
                key: 'styles',
                breadcrumb: i18n.t('admin.navigation.schema.styles'),
            },
        },
    ],
}]
